import { Injectable } from '@angular/core';
import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { CurrentUser } from '../../_model/auth/authentication.model';
import { Toast, ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(
    private loginService: AuthenticationService,
    private router: Router,
    private toast: ToastrService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    let header = new HttpHeaders();
    const urlBased = req.url;

    if (this.loginService.currentUser) {
      header = header.append('Authorization', `Bearer ${this.loginService.currentUser.access_token}`);
      if (!urlBased.includes('login') && !urlBased.includes('api-bop')) {
        const currentEpoch = Math.floor(Date.now() / 1000);
        const currentLogin: CurrentUser = JSON.parse(localStorage.getItem(this.loginService.currentLogin));
        if (currentLogin.exp <= currentEpoch) {
          this.loginService.logout();
          this.toast.error('Session Login Habis, Silahkan Login Ulang', 'Expired Login');
          return
        }
        const newRequest = req.clone({
          headers: header
        });
        return next.handle(newRequest);
      } else {
        const newRequest = req.clone();
        return next.handle(newRequest);
      }
    } else {
      const newRequest = req.clone();
      return next.handle(newRequest);
    }
  }
}
